<div id="platformTourModal">
  <div class="modal-body px-4 py-4">

    <!-- initial loader when data loading -->
    <div class="d-flex justify-content-center align-items-center w-100" *ngIf="!tourItems?.length" style="height: 500px !important; min-width: 660px; min-height: 500px !important;">
      <img *ngIf="isLoading || !isAPICallComplete" style="width: 80px;" src="../../assets/rolling-loader.gif" alt="loading...">
    </div>

    <!-- carousel -->
    <div class="carousel-container w-100 mb-3" *ngIf="tourItems?.length">
      <p-carousel
        [value]="tourItems"
        [(page)]="currentPage"
        [numVisible]="carouselConfig.numVisible"
        [numScroll]="carouselConfig.numScroll"
        [circular]="carouselConfig.circular"
        [showNavigators]="carouselConfig.showNavigators"
        (onPage)="pageChangeEventHandler($event)"
        class="tour-carousel"
      >
        <ng-template let-item pTemplate="item">
          <div class="item">
            <div class="item-content d-flex flex-column justify-content-center align-items-center">
              <!-- heading -->
              <div class="w-100">
                <div class="row" [ngClass]="{ 'mb-1': item?.tour_config?.subtitle }">
                  <div class="col">
                    <div class="d-flex justify-content-center align-items-center">
                      <p class="text-black font-weight-600 f-24 text-center mb-0">{{ item?.title || '-' }}</p>
                    </div>
                  </div>
                </div>
                <div class="row" [ngClass]="{ 'mb-1': item?.tour_config?.subtitle }" [ngStyle]="{ 'visibility': !item?.tour_config?.subtitle ? 'hidden': '' }">
                  <div class="col">
                    <div class="d-flex justify-content-center align-items-center">
                      <p class="text-black font-weight-600 f-16 text-center mb-0">{{ item?.tour_config?.subtitle || '-' }}</p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- video/gif player -->
              <div class="w-100">
                <div *ngIf="displayMode === 'gif'">
                  <div class="d-flex justify-content-center align-items-center w-100">
                    <img *ngIf="isLoading || !isAPICallComplete" style="width: 80px;" src="../../assets/rolling-loader.gif" alt="loading...">
                    <img [hidden]="isLoading || !isAPICallComplete" [src]="item?.tour_config?.gif_url" [alt]="item?.title" width="660" height="352" loading="eager" (load)="onLoad()">
                  </div>
                </div>

                <div class="d-flex justify-content-center align-items-center" *ngIf="displayMode === 'youtube'">
                  <youtube-player class="youtube-player" width="660" height="352" [videoId]="item?.tour_config?.yt_video_id" style="width: 660px !important; height: 352px !important;">
                  </youtube-player>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </p-carousel>
    </div>

    <!-- cta row -->
    <section>
      <div class="row actions">
        <div class="col">
          <div class="d-flex justify-content-around align-items-center">
            <button data-testid="auto-app-platform-tour-modal-button-1" class="col-md-2 wc-ghostBtn py-2 font-weight-600 text-webbtree-green" (click)="isFirstPage ? closeActiveModal('SKIP') : setPage('previous')">
              {{ isFirstPage ? 'Skip' : 'Previous' }}
            </button>
            <button data-testid="auto-app-platform-tour-modal-button-2" class="wc-ghostBtn bg-blue py-2 border-0 font-weight-600" [disabled]="isLoading || !isAPICallComplete || !tourItems[currentPage]?.tour_config?.allow_video" [ngStyle]="{ 'cursor': !tourItems[currentPage]?.tour_config?.allow_video ? 'not-allowed': '' }"
              (click)="switchDisplayMode(displayMode === 'gif' ? 'youtube' : 'gif')"
            >
              <span class="text-webbtree-green d-flex justify-content-center align-items-center">
                <i class="fa-solid fa-play mr-2"></i>
                <span>Watch the {{ displayMode === 'gif' ? 'Video' : 'Preview' }}</span>
              </span>
            </button>
            <button data-testid="auto-app-platform-tour-modal-button-3" class="col-md-2 wc-btn bg-blue py-2 font-weight-600" (click)="reachedLastPage ? closeActiveModal('SKIP') : setPage('next')">
              {{ reachedLastPage ? 'Done' : 'Next' }}
            </button>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
